import { render } from "./ChatPageSubtitle.vue?vue&type=template&id=0f284f64&scoped=true"
import script from "./ChatPageSubtitle.vue?vue&type=script&lang=js"
export * from "./ChatPageSubtitle.vue?vue&type=script&lang=js"

import "./ChatPageSubtitle.vue?vue&type=style&index=0&id=0f284f64&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f284f64"]])

export default __exports__